const REQUESTS_PER_DEVICE = 50;

/** Format internal family_id for support display (v7 style G-XXXXXX). */
export function formatGroupDisplayId(familyId: string): string {
  const raw = familyId.replace(/^fam_/i, '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  if (raw.length >= 6) {
    const letters = raw.replace(/[^A-Z]/g, '').padEnd(3, 'X').slice(0, 3);
    const digits = raw.replace(/[^0-9]/g, '').padEnd(3, '0').slice(0, 3);
    if (/[A-Z]{3}/.test(letters) && /\d{3}/.test(digits)) {
      return `G-${letters}${digits}`;
    }
    return `G-${raw.slice(0, 6)}`;
  }
  return `G-${raw.padEnd(6, '0').slice(0, 6)}`;
}

export function dailyAllowance(deviceCount: number, perDevice = REQUESTS_PER_DEVICE): number {
  return Math.max(1, deviceCount) * perDevice;
}

export const FAM_NAME_RE = /^[A-Za-z0-9 '\-.]{1,20}$/;
export const PERSON_NAME_RE = /^[A-Za-z][A-Za-z0-9 ]{0,11}$/;
